var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isInDashboard,
            expression: "!isInDashboard",
          },
        ],
        class: {
          "has-logo": _vm.showLogo,
          "sidebar-inner": true,
        },
        on: {
          mouseenter: _vm.handleMouseEnter,
          mouseleave: _vm.handleMouseLeave,
        },
      },
      [
        _vm.showLogo
          ? _c("logo", { attrs: { collapse: _vm.isCollapse } })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "el-scrollbar",
          { attrs: { "wrap-class": "scrollbar-wrapper" } },
          [
            _c(
              "el-menu",
              {
                attrs: {
                  "default-active": _vm.activeMenu,
                  collapse: _vm.isCollapse,
                  "background-color": _vm.variables.menuBg,
                  "text-color": _vm.variables.menuText,
                  "unique-opened": true,
                  "active-text-color": _vm.settings.theme,
                  "collapse-transition": false,
                  mode: "vertical",
                },
              },
              _vm._l(_vm.permission_routes, function (route) {
                return _c("sidebar-item", {
                  key: route.path,
                  attrs: { item: route, "base-path": route.path },
                })
              }),
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _vm.isInDashboard || (_vm.isInDashboard && _vm.isHovered)
      ? _c(
          "div",
          {
            class: {
              "has-logo": _vm.showLogo,
              "sidebar-trigger": true,
            },
            on: {
              mouseenter: _vm.handleMouseEnter,
              mouseleave: _vm.handleMouseLeave,
            },
          },
          [
            _vm.showLogo
              ? _c("logo", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isHovered,
                      expression: "isHovered",
                    },
                  ],
                  attrs: { collapse: _vm.isCollapse },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "el-scrollbar",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isHovered,
                    expression: "isHovered",
                  },
                ],
                attrs: { "wrap-class": "scrollbar-wrapper" },
              },
              [
                _c(
                  "el-menu",
                  {
                    attrs: {
                      "default-active": _vm.activeMenu,
                      collapse: _vm.isCollapse,
                      "background-color": _vm.variables.menuBg,
                      "text-color": _vm.variables.menuText,
                      "unique-opened": true,
                      "active-text-color": _vm.settings.theme,
                      "collapse-transition": false,
                      mode: "vertical",
                    },
                  },
                  _vm._l(_vm.permission_routes, function (route) {
                    return _c("sidebar-item", {
                      key: route.path,
                      attrs: { item: route, "base-path": route.path },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }